import { Box, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { formatText, FORMAT_TYPE } from 'src/utils/era-package'
import {STATEMENT_TYPE} from "../../shared";

const CellContent = ({ value = 0, number, ...props }) => <TableCell {...props}>
  <Stack direction='row'
    justifyContent='space-between'
  >
    {!number && <pre>$</pre>}
    <Box component='pre' ml='auto'>
      {number ? String(value || 0) : formatText(value, FORMAT_TYPE.currency, 'no-symbol')}
    </Box>
  </Stack>
</TableCell>

const borderSx = {
  borderLeft: 1, borderRight: 1,
  borderColor: 'divider'
}

export const SummaryTotal = ({type, final, data }) => {
  return <TableContainer>
    <Table sx={{ width: 'auto' }} size='small'>
      <TableHead><TableRow>
        <TableCell>
          Description
        </TableCell>
        <TableCell>{type === STATEMENT_TYPE.pmsDaily ? 'Totals' : 'Preliminary Totals'}</TableCell>
        {final && <>
          <TableCell sx={borderSx}>Final Totals</TableCell>
          <TableCell>Difference</TableCell>
        </>}
      </TableRow></TableHead>
      <TableBody>
        {Object.entries(data || {}).map(([key, val], i) => <TableRow key={i}>
          <TableCell>{val?.displayName || key}</TableCell>
          <CellContent value={val?.preliminaryTotals}
            number={key.startsWith('totalNum')}
          />
          {final && <>
            <CellContent value={val?.finalTotals}
              sx={borderSx} number={key.startsWith('totalNum')}
            />
            <CellContent value={val?.difference}
              number={key.startsWith('totalNum')}
            />
          </>}
        </TableRow>)}
      </TableBody>
    </Table>
  </TableContainer>
}